import React, { Component } from 'react';

var __html = require('./shrinkyprivacy.html.js');
var template = { __html: __html };

class shrinkyprivacy extends Component {
  render() {
    return(
      <div dangerouslySetInnerHTML={template}></div>
    );
  }
}
export default shrinkyprivacy;